mutation TravelerExport($input: TravelerExportInput!) {
  travelerExport(input: $input) {
    exportResult {
      exportCycles
    }
  }
}
